export default (api) => {
	// initial state
	const state = {
		list: []
	}

	// getters
	const getters = {
		list: state => {
			return state.list
		}
	}

	// actions
	const actions = {
		getList: (context) => {
			return new Promise((resolve, reject) => {
				if(context.state.list && context.state.list.length) {
					resolve()
					return
				}

				api.get().then(res => {
					context.commit('setList', res)
					resolve()
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		flush: (context) => {
			context.commit('setList', [])
		},
		create: (context, obj) => {
			return new Promise((resolve, reject) => {
				api.post(obj).then(res => {
					resolve(res)
					obj.id = res[0]
					context.commit('create', obj)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		update: (context, obj) => {
			return new Promise((resolve, reject) => {
				return api.put(obj.id, obj).then(res => {
					resolve(res)
					context.commit('update', obj)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		delete: (context, obj) => {
			return new Promise((resolve, reject) => {
				api.delete(obj.id).then(res => {
					resolve(res)
					context.commit('delete', obj)
				})
				.catch(err => {
					reject(err)
				})
			})
		}
	}

	// mutations
	const mutations = {
		setList: (state, list) => {
			state.list = list
		},
		create: (state, obj) => {
			state.list.push(obj)
		},
		update: (state, obj) => {
			state.list.every((item, i) => {
				if(item.id === obj.id) {
					state.list.splice(i, 1, obj)
					return false
				}
				return true
			});
		},
		delete: (state, obj) => {
			state.list.every((item, i) => {
				if(item.id === obj.id) {
					state.list.splice(i, 1)
					return false
				}
				return true
			})
		}
	}

	return {
		state,
		getters,
		actions,
		mutations
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/base.js